import {i18n} from '@/plugins/i18n';
import {eventType} from "@/constants/FraudEventType"
import action from "@/views/user/datatable/actions.vue";

const routerLink = (id, route_name, title) => {
    let template = new action({
        props: {
            id,
            route_name,
            title
        }
    })

    template.id = id
    template.route_name = route_name
    template.title = title
    return template.$mount().$el
}
export default [
    {
        field: 'id',
        title: '#',
        width: 40,
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'user',
        title: i18n.t('label.user_full_name'),
        width: 90,
        sortable: false,
        template: (row) => {
            return `<a href="/users/${row.user_id}/details">${row.user}</a>`
            // return routerLink(row.user_id, 'users_details', row.user)
        },
        textAlign: 'center',
    },
    {
        field: 'transaction_id',
        width: 90,
        title: i18n.t('label.reference_id'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'amount',
        width: 80,
        title: i18n.t('label.price'),
        sortable: false,
        textAlign: 'center',
    },
    {
        field: 'event_type',
        width: 80,
        title: i18n.t('label.event_type'),
        template: (row) => {
            if (row.event_type == eventType.MISS_MATCH_AMOUNT)
                return `<div class='badge badge-dark'>${i18n.t('fraud_events.miss_match_amount')}</div>`;
            else if (row.event_type == eventType.MISS_MATCH_CARD_NUMBER)
                return `<div class='badge badge-danger'>${i18n.t('fraud_events.miss_match_card_number')}</div>`;
            else if (row.event_type == eventType.MISS_MATCH_TOKEN)
                return `<div class='badge badge-warning'>${i18n.t('fraud_events.miss_match_token')}</div>`;

        },
        sortable: true,
        textAlign: 'center',
    },
    {
        field: 'created_at',
        title: i18n.t('label.created_at'),
        width: 80,
        sortable: true,
        textAlign: 'center',
    },

]